export default __webpack_public_path__ + "static/media/chaise-rectangle-2-breaks.41431625.webp";